import { vars } from '@etg/wings';

export const getStepGradient = (currentStep: number, numberOfSteps: number) => {
  const breakpoint = (currentStep / numberOfSteps) * 100;
  return [
    `${vars.colors.decoration.primary} 0%`,
    `${vars.colors.decoration.primary} calc(${breakpoint}% + 14px)`,
    `${vars.colors.decoration.secondary} calc(${breakpoint}% + 14px)`,
  ].join(',');
};
